import * as actionTypes from './actionTypes';

export const toggleSidebar = () => {
    return {
        type: actionTypes.TOGGLE_SIDEBAR,
    };
};

export const closeSidebar = () => {
    return {
        type: actionTypes.CLOSE_SIDEBAR,
    };
};

export const setLang = (lang) => {
    return {
        type: actionTypes.SET_LANG,
        lang: lang
    };
};
